import React, { memo } from 'react';
import { areEqual } from 'Utils/equalityChecks';
import { Modal } from 'Components/Modal';
import { PurpleButton } from 'Components/Button';

import { RoomEquipment } from 'Containers/RocketDry/types';

import classes from './deleteRoomEquipmentModal.module.css';

interface Props {
  // modal variables
  isOpen: boolean;
  // equipment variables
  equipment: RoomEquipment;
  // modal functions
  modalCloseClick: (e: any) => void;
  onDeleteButtonClick: (e: any) => void;
}

function DeleteRoomEquipmentModal({ isOpen, equipment, modalCloseClick, onDeleteButtonClick }: Props) {
  return (
    <Modal
      id="delete-equipment-modal"
      classes={classes}
      title="Delete Equipment"
      isOpen={isOpen}
      modalHeader
      dataBsBackdrop="static"
      dataBsKeyboard="false"
      modalCloseClick={modalCloseClick}
    >
      <div className={classes.deleteModalCopy}>
        <p>
          Are you sure you want to delete
          {` ${equipment.name}`}?
        </p>
        <p>You will not be able to undo this action.</p>
      </div>

      <div className={`modal-footer ${classes.modalFooter}`}>
        <PurpleButton onClick={modalCloseClick} className={classes.cancelButton}>
          Cancel
        </PurpleButton>
        <PurpleButton onClick={onDeleteButtonClick} className={classes.deleteButton}>
          Delete
        </PurpleButton>
      </div>
    </Modal>
  );
}

const DeleteRoomEquipmentModalMemo = memo(DeleteRoomEquipmentModal, areEqual);

export { DeleteRoomEquipmentModalMemo as DeleteRoomEquipmentModal };
